// Interceptors no window.axios (a instancia global que todo o app usa -
// o axios "@axios" de libs/axios.js nao e usado em lugar nenhum).
import router from '../router'

window.axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.authorization = 'Bearer ' + token
  }
  return config
})

window.axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.clear()
      router.push('/login').catch(() => {})
    }
    return Promise.reject(error)
  }
)
